import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import StockModelCardCaptionTemplate from './StockModelCardCaptionTemplate';
import { rem } from 'polished';

export const StockModelCardCaptionStyled = styled(StockModelCardCaptionTemplate)`
    /* Selectors are in mark up order => dont change spacifity and keep it this way! */

    margin: 0;
    font-size: ${({ theme }) => theme.fontSizes.textSmall};

    .stockModelCard-imageContainer {
        &--image {
            width: 100%;
        }

        &--info {
            padding: 0 ${rem('20px')};

            &__list {
                display: flex;
                flex-flow: row;
                flex-wrap: wrap;
                width: 100%;
                overflow: visible;
                dt {
                    flex: 0 0 30%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    margin-bottom: ${rem('8px')};
                }
                dd {
                    flex: 0 0 70%;
                    margin-left: auto;
                    text-align: left;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }

    .highlighted-text {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-transform: uppercase;
    }
`;
